import { formatDateTimeBR } from '@/shared/utils/date-validator'

export default {
  name: 'ModalHistoricoExame',

  props: {
    historico: {
      type: Array,
      default: () => []
    },
    itemFocado: {
      type: Object,
      default: null
    },
    dicomPlusId: {
      type: [String, Number],
      default: ''
    }
  },

  computed: {
    hasNameSystemUpdate () {
      return Array.isArray(this.historico) && this.historico.some(i => !!i.nameSystemUpdate)
    },
    hasDicomPlusOrigin () {
      return Array.isArray(this.historico) && this.historico.some(i => !!i.dicomPlusOrigin)
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.itemFocado) {
        this.scrollToFocusedItem()
      }
    })
  },

  methods: {
    formatDate(date) {
      return formatDateTimeBR(date)
    },
    formatBoolean(value) {
      if (value === null || value === undefined) return '-'
      return value ?  this.$i18n.t('dicom_plus.yes') :  this.$i18n.t('dicom_plus.no')
    },

    badgeClass (value) {
      if (value === null || value === undefined) return 'badge-neutral'
      return value ? 'badge-true' : 'badge-false'
    },

    isFocused(item) {
      if (!this.itemFocado) return false
      return item.date === this.itemFocado.date &&
             item.exameId === this.itemFocado.exameId &&
             item.status === this. itemFocado.status
    },

    scrollToFocusedItem() {
      setTimeout(() => {
        const focusedElement = this.$el.querySelector('.timeline-item-focused')
        if (focusedElement) {
          focusedElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
      }, 100)
    }
  }
}
